import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../locale/i18n";
import "./style.scss";
import Logo from "../../assets/logo/logo.png";

const AppFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="app-footer">
      <div className="content">
        <div className="sitemap-wrap">
          <div className="sitemap">
            <Link to="/company" className="title">
              {t(`appFooter.company`)}
            </Link>
            <Link to="/company" className="sub">
              {t(`appFooter.coreValue`)}
            </Link>
            <Link to="/company" className="sub">
              {t(`appFooter.leadership`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link to="" className="title">
              {t(`appFooter.product`)}
            </Link>
            <Link to="/product/ai/graph_rag" className="sub">
              {t(`appFooter.ai`)}
            </Link>
            <Link to="/product/dbms/agents_graph" className="sub">
              {t(`appFooter.dbms`)}
            </Link>
            <Link to="/product/ontology" className="sub">
              {t(`appFooter.ontology`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link to="/service/pgts" className="title">
              {t(`appFooter.service`)}
            </Link>
            <Link to="/service/pgts" className="sub">
              {t(`appFooter.pgts`)}
            </Link>
            <Link to="/service/education" className="sub">
              {t(`appFooter.education`)}
            </Link>
            <Link to="/service/techportal" className="sub">
              {t(`appFooter.techPortal`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link to="/resource" state={{ index: 0 }} className="title">
              {t(`appFooter.resource`)}
            </Link>
            <Link to="/resource" state={{ index: 0 }} className="sub">
              {t(`appFooter.manual`)}
            </Link>
            <Link to="/resource" state={{ index: 1 }} className="sub">
              {t(`appFooter.whitePaper`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link to="/newsroom" className="title">
              {t(`appFooter.newsRoom`)}
            </Link>
            <Link to="/newsroom" className="sub">
              {t(`appFooter.pressRelease`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link to="/ir" state={{ index: 0 }} className="title">
              {t(`appFooter.ir`)}
            </Link>
            <Link to="/ir" state={{ index: 0 }} className="sub">
              {t(`appFooter.report`)}
            </Link>
            <Link to="/ir" state={{ index: 1 }} className="sub">
              {t(`appFooter.announcement`)}
            </Link>
            <Link to="/ir" state={{ index: 2 }} className="sub">
              {t(`appFooter.ci`)}
            </Link>
          </div>
          <div className="sitemap">
            <Link
              target="blank"
              to="https://jumpit.saramin.co.kr/company/MjIwODg2ODQwOA==?company_nm=%EC%8A%A4%EC%B9%B4%EC%9D%B4%EC%9B%94%EB%93%9C%EC%99%80%EC%9D%B4%EB%93%9C"
              className="title"
            >
              {t(`appFooter.career`)}
            </Link>
          </div>
        </div>
        <div className="info-wrap">
          <img src={Logo} alt="logo" />
          <div className="info-wrap">
            <h5>{t(`appFooter.SKAI`)}</h5>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td>{t(`appFooter.CEO`)}</td>
                  <td>{t(`appFooter.shin`)}</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.brn`)}</td>
                  <td>220-88-68408</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.address`)}</td>
                  <td>{t(`appFooter.addressValue`)}</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.contactUs`)}</td>
                  <td>inquiry@skaiworldwide.com</td>
                </tr>
                {i18n.language === "ko" && (
                  <tr>
                    <td>{t(`appFooter.mainTel`)}</td>
                    <td>070-4800-3517</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="link-wrap">
              <Link to="/privacy" target="blank">
                {t(`appFooter.privacy`)}
              </Link>
              <strong>FamilySite</strong>
              <Link to="https://www.skaiintelligence.co.kr/" target="blank">
                {t(`appFooter.skaiIntelligence`)}
              </Link>
              <Link to="http://www.directorscompany.co.kr" target="blank">
                {t(`appFooter.directorCompany`)}
              </Link>
              <Link to="http://creativeair.co.kr/" target="blank">
                {t(`appFooter.creativeAir`)}
              </Link>
            </div>
            <div className="sns-wrap">
              <Link
                to="https://www.linkedin.com/company/skaiworldwide"
                target="blank"
              >
                {/* <img src={LinkedIn} alt="" /> */}
              </Link>
              <Link to="https://www.youtube.com/@skaiworldwide" target="blank">
                {/* <img src={Youtube} alt="" /> */}
              </Link>
            </div>
          </div>
        </div>
        <div className="copy-wrap">
          <span>
            Copyright © 2025 SKAI Worldwide Co., Ltd. All Rights Reserved.
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
